import { IVROptionEditorOutput } from './ivr-option-editor-output';

export const defaultIVROptionEditorOutput: IVROptionEditorOutput = {
  displayName: '',
  description: '',
  keyPresses: [],
  phrases: [],
  commands: { commands: [] },
};
